module.exports = __webpack_public_path__ + "media/images/logo_white-0c5eafb931bb7da3508c3b90e08ccd81.png";